import React, { useEffect, useState } from 'react';
import JobCard from '../components/JobCard';
import AccessibilityBar from '../components/AccessibilityBar';
import { API_BASE_URL } from '../config/apiConfig';
import './PageStyles.css'; // Optional shared styling

const TeachingJobs = () => {
  const [teachingJobs, setTeachingJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFallback, setShowFallback] = useState(false);
  const [fallbackJobs, setFallbackJobs] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/jobs?limit=1000`)
      .then(response => response.json())
      .then(data => {
        const allJobs = data.jobs || [];
        const filtered = allJobs.filter(job => 
          job.jobType === 'Teaching' 
        );

        if (filtered.length > 0) {
          setTeachingJobs(filtered);
        } else {
          setShowFallback(true);
          setFallbackJobs(allJobs);
        }

        setLoading(false);
      })
      .catch(() => {
        setTeachingJobs([]);
        setFallbackJobs([]);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <AccessibilityBar />
      <div className="container">
        <h1>📚 Teaching Jobs</h1>

        {loading ? (
          <p>Loading jobs...</p>
        ) : showFallback ? (
          <>
            <p>No Teaching jobs found. Showing all available jobs instead:</p>
            <div className="grid">
              {fallbackJobs.map(job => (
                <JobCard key={job._id} job={job} />
              ))}
            </div>
          </>
        ) : (
          <div className="grid">
            {teachingJobs.map(job => (
              <JobCard key={job._id} job={job} />
            ))}
          </div>
        )}
      </div>
      
    </>
  );
};
export default TeachingJobs;